const COMMONS_DICTIONARY = {
  table: {
    objects: [
      {
        label: 'Таблица',
        value: 'Таблица',
      },
    ],
    links: [
      {
        label: 'Сокращения вида т., таб., табл.',
        value: 'т(аб(л)?)?\\.',
      },
      {
        label: 'Таблица и словоформы',
        value: 'таблиц[а-я]*',
      },
    ],
    params: {
      mark: 'т',
      title: 'Таблица',
    },
  },
  addon: {
    objects: [
      {
        label: 'Приложение',
        value: '((Приложение)|(ПРИЛОЖЕНИЕ))',
      },
    ],
    links: [
      {
        label: 'Сокращения вида п., пр., прил.',
        value: 'п(р(ил)?)?\\.',
      },
      {
        label: 'Приложение и словоформы',
        value: 'приложен[а-я]*',
      },
    ],
    params: {
      mark: 'п',
      title: 'Приложение',
    },
  },
  picture: {
    objects: [
      {
        label: 'Рисунок',
        value: '((Рисунок)|(РИСУНОК))',
      },
    ],
    links: [
      {
        label: 'Сокращения вида р., рис.',
        value: 'р(ис)?\\.',
      },
      {
        label: 'Рисунок и словоформы',
        value: 'рисун[а-я]*',
      },
    ],
    params: {
      mark: 'р',
      title: 'Рисунок',
    },
  },
  formula: {
    objects: [
      {
        label: 'Формула',
        value: '((Формула)|(ФОРМУЛА))',
      },
      {
        label: 'Без метки',
        value: '',
      },
    ],
    links: [
      {
        label: 'Сокращения вида ф., форм.',
        value: 'ф(орм)?\\.',
      },
      {
        label: 'Формула и словоформы',
        value: 'формул[а-я]*',
      },
      {
        label: 'Уравнение и словоформы',
        value: 'уравнен[а-я]*',
      },
    ],
    params: {
      mark: 'ф',
      title: 'Формула',
    },
  },
};

const PAGES_DICTIONARY = {
  Cleanup: {
    label: 'Создание нового документа',
    withIndex: false,
  },
  Markup: {
    label: 'Разметка структуры документа',
    withIndex: false,
  },
  Create: {
    label: 'Разметка требований документа',
    withIndex: true,
  },
  Update: {
    label: 'Обновление связанных классификаторов',
    withIndex: true,
  },
  ClassifiersSelect: {
    label: 'Классификаторы',
    withIndex: false,
  },
  ClassifierTables: {
    label: 'Таблицы классификатора',
    withIndex: true,
  },
  ClassifiersCreate: {
    label: 'Параметры классификатора',
    withIndex: false,
  },
};

const OBJECTS_FINISH_DICTIONARY = {
  objects: 'Завершить разметку объектов и перейти к форматированию примечаний?',
  selection:
    'Завершить разметку структуры документа без разметки объектов и отправить документ на выделение требований?',
  last: 'Завершить разметку структуры и отправить документ на выделение требований?',
};

const AI_STATUS = {
  handled: {
    type: 'success',
    text: 'Рекомендации ИИ по документу сформированы.',
  },
  handling: {
    type: 'warning',
    text: 'Документ обрабатывается для формирования рекомендаций.',
  },
  'no-such-document': {
    type: 'error',
    text: 'Документ отутствует в базе данных ИИ.',
  },
  'no-such-status': {
    type: 'error',
    text: 'Статус документа не определен.',
  },
  failure: {
    type: 'error',
    text: 'Произошла ошибка при обработке или получении документа.',
  },
};

export { COMMONS_DICTIONARY, PAGES_DICTIONARY, OBJECTS_FINISH_DICTIONARY, AI_STATUS };
